module.exports = __webpack_public_path__ + "static/img/active7.a209edc6.png";